/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */
import "./static/css/all.min.css";
import 'react-toastify/dist/ReactToastify.css';

import React from "react";
import { AuthProvider } from "./src/hooks/useAuth";
import TrackSession from "./src/components/TrackSession";
import {
  MEASUREMENT_ID,
  registerOutboundLinkTracking,
} from "./src/utils/ga4";

export const wrapRootElement = ({ element }) => (
  <AuthProvider>
    <TrackSession />
    {element}
  </AuthProvider>
);

export const onClientEntry = () => {
  registerOutboundLinkTracking();
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window === "undefined" || !MEASUREMENT_ID) return;
  if (typeof window.gtag !== "function") return;
  window.gtag("config", MEASUREMENT_ID, {
    page_path: location.pathname + location.search,
  });
};

